import React, { Component } from 'react'
import PropTypes from 'prop-types'
import bowser from 'bowser'
import { FormattedMessage, injectIntl } from 'react-intl'

import { LOCALE_PREFIX } from './constants'

import HocDialogComponent from '../../../../services/dialog/hocDialogComponent'

import './style.scss'

@injectIntl
@HocDialogComponent
export default class ReportOwnershipConfirm extends Component {
    static propTypes = {
        closeDialog: PropTypes.func.isRequired,
        intl: PropTypes.object.isRequired,
        type: PropTypes.string.isRequired,
    }

    onButtonClick = (buttonType) => {
        if (buttonType === 'close') {
            const { type, closeDialog } = this.props

            closeDialog(type)
        }
    }

    defineHeader = () => ({
        text: this.props.intl.formatMessage({ id: `${LOCALE_PREFIX}.headerText` }),
        icon: 'info',
    })

    defineFooter = () => [
        {
            type: 'close',
            text: this.props.intl.formatMessage({ id: `${LOCALE_PREFIX}.buttonText` }),
        },
    ]

    render() {
        return (
            <div className={'report-ownership-dialog'}>
                <div>
                    <div>
                        {' '}
                        <FormattedMessage id={`${LOCALE_PREFIX}.firstText`} />{' '}
                    </div>
                    <div>
                        {' '}
                        <FormattedMessage id={`${LOCALE_PREFIX}.secondText`} />{' '}
                    </div>
                    <div className={'ownership-dialog-contacts'}>
                        <a className={'ownership-dialog-email'} href={'mailto:podpora.cz@dnb.com'}>
                            <FormattedMessage id={`${LOCALE_PREFIX}.email`} />
                        </a>
                        <a
                            className={'ownership-dialog-phone'}
                            href={`${bowser.mobile ? 'tel:' : 'skype:'}274 800 000`}
                        >
                            <FormattedMessage id={`${LOCALE_PREFIX}.phone`} />
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}
